import { DragSource } from 'react-dnd-compat';
import { WigglyAnimation } from './WigglyAnimation';
import EPAddableTile from 'editor-components/sidebar/addableComponents/EPAddableTile';
import { useState } from 'react';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const PATAGONIA_TILE_SIZE = 80;
const PATAGONIA_TEXT_SIZE = 11;
const dragSource = {
  beginDrag(props) {
    const dragItem = {
      blockType: props.buildingBlock.id,
      type: DRAG_TYPES.ADD_BUILDING_BLOCK
    };
    if (props.onDragStart) props.onDragStart(dragItem);
    return dragItem;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop() && props.onDragEnd) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    if (props.onDragEnd) props.onDragEnd(dropResult, dragItem);
  }
};
function DraggableBuildingBlock({
  buildingBlock,
  sidebarIframeBody,
  connectDragSource,
  isDragging
}) {
  const [isWiggly, setIsWiggly] = useState(false);
  const toggleWiggleBuildingBlock = () => {
    setIsWiggly(!isWiggly);
  };
  const {
    id,
    displayName,
    FoundationsIcon
  } = buildingBlock;
  const draggableBuildingBlock = /*#__PURE__*/_jsx("li", {
    "data-hs-dragdrop": true,
    "data-building-block-id": id,
    "data-test-building-block-name": displayName,
    children: /*#__PURE__*/_jsx(WigglyAnimation, {
      $animationName: "clickTileItem",
      $isWiggly: isWiggly,
      onClick: toggleWiggleBuildingBlock,
      onAnimationEnd: toggleWiggleBuildingBlock,
      children: /*#__PURE__*/_jsx(EPAddableTile, {
        useOnDark: true,
        _bodyElement: sidebarIframeBody,
        iconNode: /*#__PURE__*/_jsx(FoundationsIcon, {
          size: "500"
        }),
        text: displayName,
        isDragging: isDragging,
        tileSize: PATAGONIA_TILE_SIZE,
        textSize: PATAGONIA_TEXT_SIZE,
        hoverStyleTokens: {
          boxShadow: '300'
        }
      })
    })
  });
  if (connectDragSource) {
    return connectDragSource(draggableBuildingBlock);
  }
  return draggableBuildingBlock;
}
export default DragSource(DRAG_TYPES.ADD_BUILDING_BLOCK, dragSource, monitor => ({
  isDragging: monitor.isDragging()
}))(DraggableBuildingBlock);